import { ABOUT_IMAGE } from "../../../utils/constants";
import CountUp from "./CountUp";
import Reveal from "./Reveal";

/* static styles outside component */
const gridStyle = {
  backgroundImage:
    "linear-gradient(rgba(179,18,158,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(179,18,158,0.4) 1px, transparent 1px)",
  backgroundSize: "60px 60px",
};

const diagonalStyle = {
  background:
    "linear-gradient(135deg, #B3129E44 0%, transparent 60%, #041122 100%)",
};

const textureStyle = {
  background:
    "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23B3129E' fill-opacity='0.6'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
};

const titleStyle = {
  fontSize: "clamp(2.2rem, 6vw, 4rem)",
};

const statStyle = {
  fontSize: "clamp(2rem,4vw,3.5rem)",
};

const stats = [
  { val: 12, suffix: "+", label: ["Years", "Experience"] },
  { val: 100, suffix: "%", label: ["Quality", "Commitment"] },
  { val: 3, suffix: "", label: ["RMC", "Plants"] },
];

const HeroSection = () => {
  return (
    <section className="relative w-full min-h-[78vh] flex items-end overflow-hidden bg-[#041122]">
      {/* grid overlay */}
      <div className="absolute inset-0 opacity-10" style={gridStyle} />

      {/* diagonal accent */}
      <div className="absolute inset-0" style={diagonalStyle} />

      {/* concrete texture feel */}
      <div
        className="absolute right-0  top-0 bottom-0 w-1/2 opacity-20"
        style={textureStyle}
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 py-8 sm:py-10 md:py-12 lg:pt-16 lg:pb-28 px-4 sm:px-6 md:px-8 lg:px-10 z-10 w-full gap-4 lg:gap-0">
        <div className="relative space-y-8 lg:space-y-12">
          <Reveal>
            <span className="inline-block text-xs lg:pl-2 font-semibold tracking-[0.3em] uppercase text-[#B3129E] ">
              [About Us]
            </span>
          </Reveal>

          <Reveal delay={120}>
            <div
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-white font-heading flex flex-col gap-y-3 sm:gap-y-4 md:gap-y-5 lg:gap-y-4 tracking-wide"
              style={titleStyle}
            >
              <span>
                Build <span className="text-[#B3129E]">Forever</span> —
              </span>
              <span>The Vision Behind</span>
              <span>Mix Masters RMC</span>
            </div>
          </Reveal>

          <Reveal delay={240}>
            <p className="text-gray-300 max-w-2xl text-xs sm:text-sm md:text-base leading-relaxed tracking-wide">
              Delivering Precision, Innovation, and Sustainability across Odisha
              and beyond. A new-age ready-mix concrete company redefining
              reliability in the RMC ecosystem.
            </p>
          </Reveal>

          {/* stats bar */}
          <Reveal delay={360}>
            <div className=" grid grid-cols-3 gap-2 sm:gap-8 lg:gap-10">
              {stats.map((s) => (
                <div key={s.label}>
                  <p
                    className="font-bebas text-[#B3129E] leading-none"
                    style={statStyle}
                  >
                    <CountUp target={s.val} suffix={s.suffix} />
                  </p>
                  <p className="text-gray-400 flex flex-col lg:flex-row  gap-1.5 text-[0.65rem] sm:text-xs tracking-widest uppercase mt-1">
                    {s.label.map((line, i) => (
                      <span key={i} className="block">
                        {line}
                      </span>
                    ))}{" "}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
        <div className="max-h-[38rem] flex-shrink-0  flex items-center justify-center">
          <img className="h-full shrink-0" src={ABOUT_IMAGE} alt="About_image" />
        </div>
      </div>
      {/* bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white via-white/80 via-40% to-transparent pointer-events-none" />
    </section>
  );
};

export default HeroSection;
